import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Kontakt from '@/components/Kontakt'
import Judaszowce from '@/components/Judaszowce'
import Szpalery from '@/components/Szpalery'
import Asortyment from '@/components/Asortyment'
import Galeria from '@/components/Galeria'
import PageNotFound from '@/components/common/PageNotFound'
import VueScrollTo from 'vue-scrollto';

Vue.use(Router)


export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {title: 'Olszewscy Szkółkarstwo Ozdobne - pojemnikowa uprawa drzew, krzewy liściaste, krzewy iglaste, byliny, pnącza. ' , description: 'Trzonem naszej produkcji jest pojemnikowa uprawa drzew. Znakiem rozpoznawczym naszej szkółki są z Judaszowce kanadyjskie (Cercis canadensis).'}
        },
        {
            path: '/kontakt',
            name: 'kontakt',
            component: Kontakt,
            meta: {title: 'Olszewscy Szkółkarstwo Ozdobne - uprawa drzew, krzewy liściaste, krzewy iglaste, byliny, pnącza - kontakt.', description: 'Szkółkarstwo Ozdobne Olszewscy - Jarosław, Renata Olszewska, ul. Strażacka 20,  42-262 Poczesna, +48 600 325 709.'}
        },
        {
            path: '/judaszowce-cercises',
            name: 'judaszowce',
            component: Judaszowce,
            meta: {title: 'Judaszowce, Cercises, uprawa drzew, krzewy liściaste, krzewy iglaste, byliny, pnącza - Olszewscy Szkółkarstwo Ozdobne Poczesna.', description: 'Kilkuletnie doświadczenie pozwoliło nam na wypracowanie najlepszych odmian Judaszowców do sadzenia w polskich ogrodach. '}
        },
        {
            path: '/szpalery-formowane',
            name: 'szpalery',
            component: Szpalery,
            meta: {title: 'Szpalery formowane - tuje, graby, wiązy, buki, dęby - Olszewscy Szkółkarstwo Ozdobne Poczesna.', description: ' Proponujemy rozwiązanie w postaci szpalerów roślinnych - graby, wiąz, buki, dęby rozpinamy na bambusowych ramkach uzyskując różnej formy i wielkości "ekrany".'}
        },
        {
            path: '/asortyment',
            name: 'asortyment',
            component: Asortyment,
            meta: {title: 'Olszewscy Szkółkarstwo Ozdobne - drzewa, krzewy liściaste, krzewy iglaste, byliny, pnącza, graby, buki, wiązy, dęby - asortyment.', description: ' Zapraszamy do współpracy odbiorców hurtowych. Dla klientów indywidualnych mamy na terenie szkółki punkt sprzedaży detalicznej.\n'}
        },
        {
            path: '/galeria',
            name: 'galeria',
            component: Galeria,
            meta: {title: 'Olszewscy Szkółkarstwo Ozdobne - pojemnikowa uprawa drzew, krzewy liściaste, krzewy iglaste, byliny, pnącza - galeria.', description: 'Zapraszamy do obejrzenia galerii zdjęć. Trzonem naszej produkcji jest pojemnikowa uprawa drzew a znakiem rozpoznawczym są z Judaszowce.'}
        },
        {

            path: "*",
            component: PageNotFound,
            meta: {title: 'Olszewscy Szkółkarstwo Ozdobne - 404'}

        }

    ],
  scrollBehavior (to, from, savedPosition) {
      if (to.hash) {
          VueScrollTo.scrollTo(to.hash, 900);
          return {selector: to.hash}
      } else if (savedPosition) {
          return savedPosition;
      } else {
          return {x: 0, y: 0}
      }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js